/**
 * Utilitários para verificação do Pacote Cenoura
 */

import { carrotService } from '../services/carrot.service';
import { CarrotRedirectDialogComponent } from '../components/carrot-redirect-dialog.component';
import { logger } from './logger.util';

/**
 * Verifica o pacote cenoura e executa uma ação
 * Se necessário, exibe a página de redirecionamento com countdown antes de executar a ação
 * 
 * @param actionCallback - Função a ser executada após a verificação (ou após o countdown)
 * @returns Promise<void>
 */
export async function checkCarrotAndExecute(
  actionCallback: () => void | Promise<void>
): Promise<void> {
  try {
    // Verificar pacote cenoura (só faz chamada à API se estiver sem conexão)
    const carrotInfo = await carrotService.checkCarrotPackage();

    // Se deve exibir countdown, abrir dialog de redirecionamento
    if (carrotInfo && carrotInfo.shouldShowCountdown()) {
      logger.debug('[CarrotUtil] Exibindo dialog de redirecionamento com countdown');
      
      // Abrir dialog de redirecionamento com callback
      CarrotRedirectDialogComponent.show(carrotInfo.countdown!, actionCallback);
      return;
    }

    // Se não deve exibir countdown, executar ação diretamente
    logger.debug('[CarrotUtil] Executando ação diretamente (sem countdown)');
    await actionCallback();
  } catch (error) {
    logger.error('[CarrotUtil] Erro ao verificar pacote cenoura:', error);
    // Em caso de erro, executar ação normalmente
    await actionCallback();
  }
}
